import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";

@Injectable({
  providedIn: 'root'
})

export class LogsService {
  ApiUrl = "/api/admin/Logs/"
  constructor(private http: RequestHandlerService) { }

  ViewFile(id: string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get( this.ApiUrl + 'GetLogFileData', params);


  }

}
